import { useEffect, useState } from 'react';
import { Avatar, Box, Divider, Drawer, Grid, IconButton, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs, styled, tableCellClasses } from '@mui/material';
import { useParams } from 'react-router-dom';
import BreadCrumb from "../../components/Breadcrumbs/Breadcrumbs";
import LegalInformation from "../../components/LegalInformation/LegalInformation";
import AccountingInformation from "../../components/AccountingInformation/AccountingInformation";
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import AccountBasicInfo from '../../components/AccountBasicInfo/AccountBasicInfo';
import AccountBankInfo from '../../components/AccountBankInfo/AccountBankInfo';
import AccountAddressInfo from '../../components/AccountAddressInfo/AccountAddressInfo';
import AccountDocumentSettingInfo from '../../components/AccountDocumentSettingsInfo/AccountDocumentSettingsInfo';
import Settings from '../../components/Settings/Settings';
import { fetchCountries } from '../../store/countryStore/countryThunk';
import { TabPanel } from '../../components/Dialog/TabPanel';
import { fetchAccountById, updateAccount, removeAccountLogoOrSign } from "../../store/accountThunk";
import styled_ from "@emotion/styled";
import moment from 'moment';
import NavigateBeforeOutlinedIcon from '@mui/icons-material/NavigateBeforeOutlined';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import CustomDialogForm from '../../components/Dialog/DialogForm';


interface StyledTabsProps {
  children?: React.ReactNode;
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const StyledTabs = styled((props: StyledTabsProps) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-indicatorSpan': {
    maxWidth: 40,
    width: '100%',
    backgroundColor: '#635ee7',
  },
});

interface TabPanelProps {
  index: number;
  value: number;
}

const StyledTabPanel = styled((props: TabPanelProps) => (
  <TabPanel
    {...props}
  />
))({
  '& .MuiBox-root': {
    backgroundColor: 'transparent !important',
    padding: '0px !important'
  }
});

interface StyledTabProps {
  label: string;
}

const StyledTab = styled((props: StyledTabProps) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: 'none',
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(15),
  marginRight: theme.spacing(1),
  color: '#545454',
  '&.Mui-selected': {
    color: '#1890ff',
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'rgba(100, 95, 228, 0.32)',
  },
}));

/**
 * Component to show account info page.
 */
const AccountInfo = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const [logoUrl, setLogoUrl] = useState('')
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const accountDetails = useAppSelector(state => state.account.accountDetails);

  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (params.accountId) {
      dispatch(fetchAccountById(params.accountId));
    }
    dispatch(fetchCountries());
  }, [params, dispatch]);

  useEffect(() => {
    let basicInfoAvaliable = true;

    const basicInfo = () => {
      try {

        if (basicInfoAvaliable) {
          setLogoUrl(accountDetails.logo)
        }
      } catch (error: any) {
        console.log('Company Profile catch block called')
      }
    };
    basicInfo();
    return () => {
      basicInfoAvaliable = false;
    };
  }, [accountDetails]);

  const handleRemoveLogoOrSign = async (logoOrSign: any) => {
    let data: any = {};
    if (logoOrSign == 'logo') {
      data.logo = true;
    }
    if (logoOrSign == 'signature') {
      data.signature = true;
    }

    console.log(data);

    try {
      await dispatch(removeAccountLogoOrSign({
        id: accountDetails._id,
        accountPayload: data,
      })).then((data) => {
        if (data) {
          dispatch(fetchAccountById(accountDetails._id));
          handleClose();
        }
      }).catch(e => {
        //console.log(e);
      });;
    } catch (error: any) {
      // Empty catch block.
    }
  }

  const onSubmit = async (data: any) => {
    // Dispatch add account action.
    try {
      await dispatch(updateAccount({
        id: accountDetails._id,
        accountPayload: data,
      })).then((data) => {
        if (data) {
          dispatch(fetchAccountById(accountDetails._id));
          handleClose();
        }
      }).catch(e => {
        //console.log(e);
      });;
    } catch (error: any) {
      // Empty catch block.
    }
  };


  return (
    <>
      <Grid container p={0} spacing={2} >

        <Grid item xs={12} ml={-1}>
          {/* <StyledBoxLoader sx={{ mt: 1 }}><CircularProgress color="inherit" /></StyledBoxLoader> */}
          <Grid container>
            <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p: 2, pl: 3, pt: 4, bgcolor: '#fff' }} style={{ height: 200 }} >
              <IconButton style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: -5, marginRight: 10, marginLeft: -5 }} size='small' >
                <NavigateBeforeOutlinedIcon style={{ fontSize: 20 }} />
              </IconButton>
              <h3 style={{ marginTop: -1, fontWeight: 600 }}>My Business Information</h3>
              <Grid container>
              {logoUrl && <Grid item xs={1} pt={3}>
                <Avatar
                  alt={'BI'}
                  imgProps={{ "referrerPolicy": 'no-referrer' }}
                  src={`${logoUrl}`}
                  variant='circular'
                  style={{ margin: 'auto', width: '100px', height: '100px', objectFit: 'cover', border: '1px solid #e9ecf1' }}
                />
                {/* <a onClick={()=> {
                  console.log("on click trigger");
                  handleRemoveLogoOrSign('logo');
                }} style={{cursor:'pointer', color: 'red'}}><RemoveCircleOutlineIcon style={{float:'right', fontSize:'20px', marginTop:-100, marginRight:10,zIndex:999}}/></a> */}
              </Grid>
              }
              <Grid item xs={10} pt={6} pl={2}>
                <h1>{accountDetails?.displayName}</h1>
              </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container p={0} spacing={2} pr={1} mt={0} style={{ overflow: 'auto', height: 'calc(100vh - 200px)' }}>
        <Grid item xs={12}>

          <Box sx={{ bgcolor: '' }}>
            <StyledTabs value={value}
              onChange={handleChange}
              aria-label="styled tabs example">
              <StyledTab label="General" />
              <StyledTab label="Banks" />
              <StyledTab label="Addresses" />
              <StyledTab label="Document Settings" />
              <StyledTab label="Settings" />
            </StyledTabs>
            <StyledTabPanel value={value} index={0} >
              <Grid container spacing={2} >
                <Grid item xs={9}>
                  <AccountBasicInfo />
                  <AccountingInformation />
                </Grid>
                <Grid item xs={3}>
                  <LegalInformation />
                </Grid>
              </Grid>
            </StyledTabPanel>
            <StyledTabPanel value={value} index={1} >
              <Grid container spacing={2} >
                <Grid item xs={9}>
                  <AccountBankInfo accountId={params.accountId || ''} />
                </Grid>
              </Grid>
            </StyledTabPanel>
            <StyledTabPanel value={value} index={2} >
              <Grid container spacing={2} >
                <Grid item xs={9}>
                  <AccountAddressInfo accountId={params.accountId || ''} />
                </Grid>
              </Grid>
            </StyledTabPanel>
            <StyledTabPanel value={value} index={3} >
              <Grid container spacing={2} >
                <Grid item xs={9}>
                  <AccountDocumentSettingInfo accountId={params.accountId || ''} />
                </Grid>
              </Grid>
            </StyledTabPanel>
            <StyledTabPanel value={value} index={4} >
              <Grid container spacing={2} >
                <Grid item xs={6}>
                  <Settings />
                </Grid>
              </Grid>
            </StyledTabPanel>
          </Box>
        </Grid>

        <Drawer
          anchor="right"
          open={open}
        >
          {<CustomDialogForm title='Update Account' open={open} data={accountDetails} onClose={handleClose} onSubmit={onSubmit} />}
        </Drawer>

      </Grid>
    </>
  );
}

export default AccountInfo;
